export const validateAdditionalDiamondFields = (filters) => {
  const fieldNames = [
    'additional_diamond_shape',
    'additional_diamond_quality',
    'additional_diamond_setting_style'
  ]
  let errs = fieldNames.filter((e) => { return filters[e] === null })

  // additional diamond quantity should be greater than 0
  if (filters.additional_diamond_quantity < 1) {
    errs = errs.concat(['additional_diamond_quantity'])
  }

  if (filters.small_diamond_id === null) {
    errs = errs.concat(['additional_diamond_size'])
  }

  return errs
}



// WEBPACK FOOTER //
// ./src/containers/jewelry/validations/additional-diamond-fields/index.js